var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("v-simple-table", [
    _c(
      "tbody",
      _vm._l(_vm.enrollmentHistory, function (item, index) {
        return _c("tr", { key: item.id }, [
          _c("td", { staticClass: "px-1 py-3" }, [
            _c("div", {
              staticClass: "soli-round",
              class: item.end ? "soli-status-red" : "accent",
              staticStyle: { width: "3px", height: "64px" },
            }),
          ]),
          _vm._v(" "),
          _c("td", [
            _c("div", { staticClass: "caption soli-grey" }, [
              _vm._v(
                "\n                    " +
                  _vm._s(`${item.start} - ${item.end ?? "Now"}`) +
                  "\n                "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "soli-grey",
                class: _vm.$vuetify.breakpoint.xsOnly ? "body-2" : "body-1",
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      item.group_event_name ?? `${item.instrument_name} Lessons`
                    ) +
                    "\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "caption soli-grey flex whitespace-nowrap" },
              [
                _c("div", { staticClass: "overflow-hidden clip-text" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(`${item.teacher_name} `) +
                      "\n                    "
                  ),
                ]),
                _vm._v(" "),
                !item.group_event_name
                  ? _c("div", { staticClass: "caption soli-grey" }, [
                      _vm._v(
                        "\n                        · " +
                          _vm._s(item.duration) +
                          " min \n                    "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "caption soli-grey" }, [
                  _vm._v(
                    "\n                        · " +
                      _vm._s(item.location_name) +
                      "\n                    "
                  ),
                ]),
                _vm._v(" "),
                item.group_event_name && item.instrument_name
                  ? _c("div", { staticClass: "caption soli-grey" }, [
                      _vm._v(
                        "\n                        · " +
                          _vm._s(item.instrument_name) +
                          "\n                    "
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "soli-grey" }, [
            _vm._v(_vm._s(item.formatAmount) + "/month"),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }